import React from "react";

import { Col, Form, Row } from "react-bootstrap";

import { Control, Controller, FieldErrors } from "react-hook-form";

import CountryDropdown from "@components/form/CountryDropdown";
import { FormErrorText } from "@components/form/FormErrorText";

import { UserDetailsInput } from "../RegisterFormTypes";

import styles from "./index.module.scss";

interface OverseasBankDetailsProps {
  control: Control<UserDetailsInput>;
  errors?: FieldErrors<UserDetailsInput>;
  isBranchAddressRequired?: boolean;
}

export const OverseasBankDetails = ({ control, errors, isBranchAddressRequired = false }: OverseasBankDetailsProps) => {
  return (
    <div className={styles["form-section"]}>
      <Row>
        <Col md={12} sm={12}>
          <Form.Group>
            <Form.Label>Overseas bank account name</Form.Label>
            <Controller
              name="bank_details.account_name"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter overseas account name"
                  isInvalid={!!errors?.bank_details?.account_name}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.account_name} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>Overseas bank SWIFT BIC code</Form.Label>
            <Controller
              name="bank_details.swift"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter SWIFT BIC Code"
                  isInvalid={!!errors?.bank_details?.swift}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.swift} />
          </Form.Group>
        </Col>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>Overseas account IBAN number</Form.Label>
            <Controller
              name="bank_details.iban"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter IBAN"
                  isInvalid={!!errors?.bank_details?.iban}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.iban} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12} sm={12}>
          <Form.Group>
            <Form.Label>Overseas country</Form.Label>
            <CountryDropdown
              fieldName="bank_details.branch_address"
              control={control}
              isRequired={false}
              isDisabled={false}
            />
            {isBranchAddressRequired && <FormErrorText error={errors?.bank_details?.branch_address} />}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={12} sm={12}>
          <Form.Group>
            <Form.Label>Overseas intermediary bank name</Form.Label>
            <Controller
              name="bank_details.intermediary_bank_name"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter intermediary bank name"
                  isInvalid={!!errors?.bank_details?.intermediary_bank_name}
                />
              )}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>Overseas intermediary bank SWIFT code</Form.Label>
            <Controller
              name="bank_details.intermediary_swift"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter SWIFT Code"
                  isInvalid={!!errors?.bank_details?.intermediary_swift}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.intermediary_swift} />
          </Form.Group>
        </Col>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>Overseas intermediary bank country</Form.Label>
            <CountryDropdown
              fieldName="bank_details.intermediary_country"
              control={control}
              isRequired={false}
              isDisabled={false}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};
